
// frontend/geopolitikia/src/hooks/useGameData.js
import { useState, useEffect, useCallback } from 'react';
import axios from '../components/AxiosInstance';

const useGameData = (initialGameState, refreshGameState, isMulti = false) => {
  const [gameState, setGameState] = useState(initialGameState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setGameState(initialGameState);
  }, [initialGameState]);

  // En mode solo, si le state du jeu change (game→win/lose),
  // on relance refreshGameState pour que App.jsx redirige.
  // En multi, les transitions sont gérées par MultiGameScreen via multiState.status.
  useEffect(() => {
    if (isMulti) return;
    if (initialGameState.state !== gameState.state) {
        refreshGameState();
    }
  }, [gameState.state, initialGameState.state, refreshGameState, isMulti]);

  return { gameState, setGameState, loading, setLoading };
};

export default useGameData;
